import axios from "@/api/http";

export function problemSearch(token, data) {
  return axios({
    url: '/api/problemAnalysis/search',
    headers: {
      'authorization': token
    },
    data: data,
    method: 'post'
  })
}

export function setNewTicketTime(token, data) {
  return axios({
    url: '/api/problemAnalysis/setNewTicketTime',
    headers: {
      'authorization': token
    },
    data: data,
    method: 'post'
  })
}

export function invitationLink(token, data) {
  return axios({
    url: '/api/problemAnalysis/invitationLink',
    headers: {
      'authorization': token
    },
    data: data,
    method: 'post'
  })
}

export function processSuspend(token, data) {
  return axios({
    url: '/api/problemAnalysis/processSuspend',
    headers: {
      'authorization': token
    },
    data: data,
    method: 'post'
  })
}

export function addProblemConfirm(token, data) {
  return axios({
    url: '/api/problemAnalysis/addProblemConfirm',
    headers: {
      'authorization': token
    },
    data: data,
    method: 'post'
  })
}

export function init(token) {
  return axios({
    url: '/api/problemAnalysis/init',
    headers: {
      'authorization': token
    },
    method: 'get'
  })
}

export function retrial(token,pid) {
  return axios({
    url: `/api/problemAnalysis/retrial/${pid}`,
    headers: {
      'authorization': token
    },
    method: 'get'
  })
}
